import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  headerLogo: {
    height: "2.5rem",
  },
  homeLogo: {
    height: "6.30rem",
  },
  progressLoader: {
    color: "#fff",
  },
  slogan: {
    color: theme.palette.background.paper,
    width: "400px",
  },
  text: {
    color: "#d5d5d5",
    fontSize: "1.1em",
    textDecoration: "none",
  },
}));



// WEBPACK FOOTER //
// ./src/pages/home/sub-pages/home-page/styles.ts